module.exports = "/images/arrow-down-round-blue.svg?1301f469aec9668e51c1a9010243ee9b";